import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/lang";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Blog() {
  const { t } = useLang();
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  if (!posts.length) return null;

  return (
    <section id="blog" className="py-20 md:py-28" style={{ background: "var(--bg-paper)" }}>
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl">
          <div className="section-eyebrow">Journal</div>
          <h2 className="mt-3 font-display text-4xl md:text-5xl" style={{ color: "var(--primary)" }}>{t.blog.title}</h2>
          <p className="mt-4 text-lg" style={{ color: "var(--text-secondary)" }}>{t.blog.sub}</p>
        </div>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {posts.slice(0, 3).map((p) => (
            <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group card-soft overflow-hidden transition-transform hover:-translate-y-2">
              {p.image_url && (
                <div className="h-52 overflow-hidden">
                  <img src={p.image_url} alt={p.title} className="w-full h-full object-cover transition-transform group-hover:scale-105" />
                </div>
              )}
              <div className="p-6">
                <div className="flex gap-2 flex-wrap">
                  {(p.tags || []).slice(0, 2).map((tag) => (
                    <span key={tag} className="text-[10px] font-semibold uppercase tracking-widest px-2.5 py-1 rounded-full" style={{ background: "var(--bg-paper)", color: "var(--primary)" }}>
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="mt-4 font-display text-2xl leading-tight" style={{ color: "var(--primary)" }}>{p.title}</h3>
                <p className="mt-3 text-sm" style={{ color: "var(--text-secondary)" }}>{p.excerpt}</p>
                <div className="mt-5 inline-flex items-center gap-1.5 font-semibold text-sm" style={{ color: "var(--terracotta)" }}>
                  {t.blog.read} <ArrowRight size={14} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
